import { jsx as _jsx } from "react/jsx-runtime";
import { Icon, IconButton, useColorMode, useColorModeValue } from "@chakra-ui/react";
import { BsMoonFill, BsFillSunFill } from "@onemind-services-llc/react-icons-ng/bs";
export const ColorModeToggle = (props) => {
    const { toggleColorMode } = useColorMode();
    const icon = useColorModeValue(BsMoonFill, BsFillSunFill);
    const iconColor = useColorModeValue("gray.600", "gray.200");
    return (_jsx(IconButton, Object.assign({ onClick: toggleColorMode, icon: _jsx(Icon, { as: icon, color: iconColor }), "aria-label": "color-mode-toggle" }, props)));
};
//# sourceMappingURL=colorModeToggle.js.map